/** Delay before hover or focus opens the "+N more" list. */
export const CALENDAR_OVERFLOW_OPEN_MS = 150;

/** Time to cross from the indicator into the popover before it closes. */
export const CALENDAR_OVERFLOW_CLOSE_MS = 320;

/** Extra pixels around the indicator and popover so the gap between them does not count as leaving. */
export const CALENDAR_OVERFLOW_POINTER_PAD = 16;

export function pointerHitsRect (x, y, rect, pad = 0) {
	if (!rect || typeof x !== 'number' || typeof y !== 'number') {
		return false;
	}
	return x >= rect.left - pad
		&& x <= rect.right + pad
		&& y >= rect.top - pad
		&& y <= rect.bottom + pad;
}

/**
 * Open after the delay only when the pointer is still on the indicator
 * or the indicator (or its popover) has focus. A click-opened list is
 * already open and must not be re-armed.
 */
export function calendarOverflowShouldOpen ({
	suppressFocus = false,
	alreadyOpen = false,
	pointerInside = false,
	focusInside = false
} = {}) {
	if (suppressFocus || alreadyOpen) {
		return false;
	}
	return Boolean(pointerInside || focusInside);
}

/**
 * Mouse-leave closes. A pinned click (touch) stays up. If the pointer is
 * still on the indicator or the popover — including when the popover opens
 * underneath a stationary pointer — it stays open.
 */
export function calendarOverflowShouldClose ({
	pinned = false,
	pointerInside = false
} = {}) {
	if (pinned) {
		return false;
	}
	return !pointerInside;
}
